import Explore, { ExploreSections } from '@components/explore/Explore';
import ClientPage from '@components/pageTypes/ClientPage';

type Props = {
  journeyId: string;
};

const ExpertJourneyEventsPage = ({ journeyId }: Props) => (
  <ClientPage helmetKey="pageTitles.client.events.show" journeyId={journeyId}>
    <Explore journeyId={journeyId} section={ExploreSections.EVENTS} />
  </ClientPage>
);

export default ExpertJourneyEventsPage;
